export function randomColorFromNb(nb: number) {
  const hue = nb * 137.508; // use golden angle approximation
  return `hsl(${hue},50%,75%)`;
}
